import { useState } from 'react';

import LockReset from '@mui/icons-material/LockReset';
import { Grid, Typography } from '@mui/material';
import { Button, useNotify, useRefresh, useUpdate, Confirm, useRecordContext, HttpError } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { HttpErrorTypography } from 'src/lib';
import { UserDetails } from 'src/models';

export const ForgotPasswordActionButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const record = useRecordContext<UserDetails>();

  const notify = useNotify();
  const refresh = useRefresh();
  const [update, { isLoading, isError, error, reset }] = useUpdate<UserDetails, HttpError>();

  const onConfirm = async () => {
    update(
      DataProviderResource.ForgotPassword,
      {
        id: record.id,
        data: {
          email: record.email,
        },
      },
      {
        onSuccess: () => {
          notify('Password reset email successfully sent.', { type: 'success' });
          onClose();
        },
        onSettled: () => {
          refresh();
        },
      },
    );
  };

  const onClose = () => {
    setIsOpen(false);
    reset();
  };

  return (
    <>
      <Button label='Forgot Password' onClick={() => setIsOpen(true)} disabled={isLoading} style={{ marginTop: '8px' }}>
        <LockReset />
      </Button>
      <Confirm
        isOpen={isOpen}
        loading={isLoading}
        title='Forgot Password'
        content={
          <Grid container direction='column' spacing={2}>
            <Grid item md={12} sm={12}>
              <Typography variant='body1'>
                Are you sure you want to send a password reset email message to user {record.email}?
              </Typography>
              <Typography variant='body2' color='textSecondary'>
                *If user is required to reset the password after account assignment, a password reset reminder email
                message will be sent instead.
              </Typography>
            </Grid>
            <Grid item md={12} sm={12}>
              {isError && <HttpErrorTypography error={error} />}
            </Grid>
          </Grid>
        }
        onConfirm={onConfirm}
        onClose={onClose}
      />
    </>
  );
};
